import { getDefaultFilterFn } from './commonListTableDefaults';

import type { DatasetsTableFilter } from '../types/pipesList.types';

export const filterLabelMapping = {
  _id: 'Dataset',
  origin: 'Origin',
  state: 'State',
  _global: 'Global',
};

export const emptyFilterDatasets: DatasetsTableFilter = Object.freeze({
  _id: {
    selected: [],
    search: [],
  },
  origin: {
    selected: [],
    search: [],
  },
  state: {
    selected: [],
    search: [],
  },
  _global: {
    selected: [],
    search: [],
  },
});

export const defaultVisibleCols = ['Dataset', 'Last modified', 'Complete index'];

export const defaultVisibleFacets = ['_id', 'origin', '_global'];

export const defaultSortBy = [
  {
    id: 'datasets-link',
    desc: false,
  },
];

export const getSystemsDefaultFilter = getDefaultFilterFn(emptyFilterDatasets);
